import CampaignDetail from './CampaignDetail';

export default CampaignDetail;
